import { ChecklistRepository } from "../../repositories/ChecklistRepository";

export class MarkItemToBeDoneLaterUseCase {
  constructor(private repository: ChecklistRepository) {}

  async execute(itemId: number): Promise<void> {
    return await this.repository.markItemToBeDoneLater(itemId);
  }
}
